export const MESSAGES ={
    WRONG_NETWORK:'Wrong network!',

    APPROVE_ASSET_SUCCESS: 'Approve Tokens successfully!',
    APPROVE_ASSET_FAIL: 'Failed to Approve Tokens!',


    SWAP_SUCCESS :'swap successfully',
    SWAP_FAIL: 'swap fails'
  }